<template>
    <div class="tonglan">
        <div class="yjdjs">
            <!--左侧内容-->
            <div class="yjdleft">
                <router-view />
            </div>
            <!--右侧导航-->
            <div class="yjdright">
                <div class="gywmbg">
                    <ul>
                        <li v-for="(link,index) in links" :key="index" :class="{'libg':currentLick === link.link}" @click="changeLink(link)">{{link.title}}</li>
                    </ul>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'About',
  data () {
    return {
      currentLick: 'Introduction',
      links: [
        { title: '公司介绍', link: 'Introduction' },
        { title: '联系我们', link: 'Contact' },
        { title: '招贤纳士', link: 'Join' },
        { title: '公司沿革', link: 'History' },
        { title: '华源网络营销中心', link: 'Yxzx' }
      ]
    }
  },
  methods: {
    changeLink (link) {
      this.currentLick = link.link
      this.$router.push({ path: link.link })
    }
  }
}
</script>
